<div class="input-component"
     [ngClass]="{'pristine': (pristine$ | async), 'valid': (validStatus$ | async), 'invalid': (invalidStatus$ | async), 'disabled': (disabled$ | async)}">
    <div class="input-wrapper">
        <div class="rating-zone">
            <div class="rating-minus-plus">
                {{ 'ITSM.VALIDATION.STARS.MINUS' | translate }}
            </div>            
            <div class="rating">
                <input type="radio"
                       [name]="inputName"
                       value="5"
                       [checked]="rating === 5" />
                <label title="5"
                       (click)='onClick(5)'></label>
            
                <input type="radio"
                       [name]="inputName"
                       value="4"
                       [checked]="rating === 4" />
                <label title="4"
                       (click)='onClick(4)'></label>
            
                <input type="radio"
                       [name]="inputName"
                       value="3"
                       [checked]="rating === 3" />
                <label title="3"
                       (click)='onClick(3)'></label>
            
                <input type="radio"
                       [name]="inputName"
                       value="2"
                       [checked]="rating === 2" />
                <label title="2"
                       (click)='onClick(2)'></label>
            
                <input type="radio"
                       [name]="inputName"
                       value="1"
                       [checked]="rating === 1" />
                <label title="1"
                       (click)='onClick(1)'></label>
            </div>
            <div class="rating-minus-plus">
                {{ 'ITSM.VALIDATION.STARS.PLUS' | translate }}
            </div>
        </div>
    </div>
    <div>
        <aa-validation2 [dirty]="dirty"
                        [messages]="failures | async">
        </aa-validation2>
    </div>
</div>
